<template>
    <div style="margin-bottom:256px;">
        <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>        
        <h3 class="text-center"> Editar Programa </h3>
        <form class="xcard" @submit.prevent="validarCampos" novalidate>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': validation.hasError('programa.idpostgrado')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> {{menu_name}}</div>
                            <input type="text" :value="parsePrograma(postgrado)" :disabled="true" class="form-control" placeholder="Seleccione">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.idpostgrado')"> {{validation.firstError('programa.idpostgrado')}} </div>
                        <p> <small>{{programa.nombre_compuesto}}</small> </p>
                    </div>
                    <!-- <div class="form-group">
                        <div class="input-group input-group-sm" :title="programa.nombre_compuesto">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Nombre</div>
                            <input type="text" :disabled="true" v-model.trim="programa.nombre_compuesto" class="form-control" placeholder="Nombre para mostrar">
                        </div>
                    </div> -->
                    <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.idsede')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Sede</div>
                            <Sedes :model="programa" :default="programa.idsede"/>
                        </div>
                        <div class="error" v-if="validation.hasError('programa.idsede')"> {{validation.firstError('programa.idsede')}} </div>
                    </div>
                    <div>
                        <label> <input type="radio" v-model="showauspicio" :value="0"> Sin auspicio <span style="margin-right:12px"></span> </label> 
                        <label> <input type="radio" v-model="showauspicio" :value="1"> Con auspicio </label>
                    </div>

                    <div v-if="showauspicio" class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.iduniversidad')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Universidad</div>
                            <Universidades :model="programa" v-bind:convenio="true" :default="programa.iduniversidad"/>
                        </div>
                        <div class="error" v-if="validation.hasError('programa.iduniversidad')"> {{validation.firstError('programa.iduniversidad')}} </div>
                    </div>
                    <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.gestion')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Gestion</div>
                            <Gestiones :model="geztion" :default="programa.gestion"/>
                        </div>
                        <div class="error" v-if="validation.hasError('programa.gestion')"> {{validation.firstError('programa.gestion')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('programa.version')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Version</div>
                            <input type="text" v-model.trim="programa.version" class="form-control" placeholder="Ingrese el numero de version">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.version')"> {{validation.firstError('programa.version')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('programa.grupo')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Grupo</div>
                            <input type="text" v-model.trim="programa.grupo" class="form-control" placeholder="Ingrese el numero de grupo">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.grupo')"> {{validation.firstError('programa.grupo')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Modalidad</div>
                            <select v-model="programa.modalidad" class="form-control">
                                <option value="S">Semi presencial</option>
                                <option value="P">Presencial</option>
                                <option value="V">Virtual</option>
                            </select>
                        </div>
                    </div>

                    <div class="xcard">
                        <label><span class="text-danger">* </span> Imagen de la portada: </label>
                        <p>Esta imagen se muestra en la pagina web, Tamaño recomendado: 1200x1200 (cuadrado)</p>
                        <div v-if="activo" class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.portada')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon">
                                    <label for="portadaFile" class="btn btn-rounded btn-success">Seleccione otra Imagen</label>
                                    <input type="file" style="visibility:hidden;" id="portadaFile" @click="resetPortadaUploader" @change="uploadPortadaImg" accept=".jpg, .jpeg, .png" ref="portadaFile" >
                                </div>
                            </div>
                            <input type="hidden" v-model.trim="programa.portada">
                            <div class="error" v-if="validation.hasError('programa.portada')"> {{validation.firstError('programa.portada')}}</div>
                        </div>
                        <div v-else>
                            <span class="text-danger"> No esta disponible la edicion porque el programa supera la fase 'EN DESARROLLO' </span>
                        </div>
                        <div class="container-fluid">
                            <img class="img-responsive" alt="PORTADA" :src="location_programa_portadas+programa.portada">
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.cuotas')}">
                            <div class="input-group-addon">Numero de Cuotas</div>
                            <input v-model.trim="programa.cuotas" type="text" class="form-control" placeholder="Numero enterp">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.cuotas')"> {{validation.firstError('programa.cuotas')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.monto_matricula')}">
                            <div class="input-group-addon">Monto de matricula</div>
                            <input v-model.trim="programa.monto_matricula" type="text" class="form-control" placeholder="Numero entero">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.monto_matricula')"> {{validation.firstError('programa.monto_matricula')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.monto_colegiatura')}">
                            <div class="input-group-addon">Monto de colegiatura</div>
                            <input v-model.trim="programa.monto_colegiatura" type="text" class="form-control" placeholder="Numero entero">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.monto_colegiatura')"> {{validation.firstError('programa.monto_colegiatura')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.monto_certificacion')}">
                            <div class="input-group-addon">Monto de certificacion</div>
                            <input v-model.trim="programa.monto_certificacion" type="text" class="form-control" placeholder="Numero entero">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.monto_certificacion')"> {{validation.firstError('programa.monto_certificacion')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.fecha_inicio')}">
                            <div class="input-group-addon">Fecha de inicio</div>
                            <Fecha :model="programa" :valueto="'fecha_inicio'" :default="programa.fecha_inicio"/>
                            <!-- <input type="text" v-model="programa.fecha_inicio" class="form-control" placeholder="Formato DD/MM/YYYY"> -->
                        </div>
                        <div class="error" v-if="validation.hasError('programa.fecha_inicio')"> {{validation.firstError('programa.fecha_inicio')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.fecha_fin')}">
                            <div class="input-group-addon">Fecha de finalizacion</div>
                            <Fecha :model="programa" :valueto="'fecha_fin'" :default="programa.fecha_fin"/>
                            <!-- <input v-model.trim="programa.fecha_fin" type="text" class="form-control" placeholder="Formato DD/MM/YYYY"> -->
                        </div> 
                        <div class="error" v-if="validation.hasError('programa.fecha_fin')"> {{validation.firstError('programa.fecha_fin')}} </div>
                    </div>

                    <div v-show="false" class="form-group">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Observacion: </div>
                        </div>
                        <textarea class="form-control" v-model.trim="programa.observacion" placeholder="Puede ingresar alguna observacion sobre este programa..." rows="5"></textarea>
                    </div> 

                    <div class="xcard">
                        <label><span class="text-danger">* </span> Imagen de Certificado (<a href="formato.psd" target="_blank" rel="">Formato "1280x908" </a>)</label>
                        <div v-if="activo" class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.arte')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon">
                                    <label for="certificadoFile" class="btn btn-rounded btn-primary">Seleccione otro Certificado</label>
                                    <input type="file" style="visibility:hidden;" id="certificadoFile" @click="resetImageUploader" @change="uploadImageCert" accept=".jpg, .jpeg, .png" ref="certificadoFile" >
                                </div>
                            </div>
                            <input type="hidden" v-model.trim="programa.arte">
                            <div class="error" v-if="validation.hasError('programa.arte')"> {{validation.firstError('programa.arte')}}</div>
                        </div>
                        <div v-else>
                            <span class="text-danger"> No esta disponible la edicion porque el programa supera la fase 'EN DESARROLLO' </span>
                        </div>
                        <div class="container-fluid">
                            <img class="img-responsive" alt="Certificado" :src="location_certificado_programa+programa.arte">
                        </div>
                    </div>
                </div>
            </div>

            <notifications group="auth" position="bottom right" />
            <notifications group="auth1" position="bottom right" />
            <notifications group="auth2" position="bottom right" />
            <notifications group="auth3" position="bottom right" />

            <hr>
            <div class="xcard">
                <p class="text-primary"> Importar modulos de otro programa: </p>
                <Programas :model="importado" />
            </div>
            <br>
            <div class="xcard">
                <AModulos :model="programa" :importado="importado" :default="programa.modulos"/>
            </div>

            

            <p class="text-center text-primary"> <b>NOTA:</b> Cuando el programa entre en fase de DESARROLLO (o Superior) no se podran modificar los datos, para solucionar esto debe bajar la fase y realizar los cambios necesarios. </p>

            <Alertas ref="alertar" />
            <p class="text-center"> {{msg}} </p>
            <button :disabled="!activo" type="submit" class="btn btn-sm btn-azul center-block" data-toggle="modal" data-target="#modal-confirmar"> Guardar Cambios </button>
        </form>

        <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    </div>
</template>

<script>
import { Validator } from 'simple-vue-validator'
import { error, exito } from '@/components/Utils.js'
import xaxios from '@/xaxios'
import Sedes from '@/components/ASedes.vue'
import Universidades from '@/components/AUniversidades.vue'
import Gestiones from '@/components/AGestiones.vue'
import Alertas from '@/components/AAlertas.vue'
import AModulos from '@/components/ASelecionar-modulos.vue'
import Fecha from '@/components/AFecha'
import Programas from '@/components/AProgramas'
import gql from 'graphql-tag'
export default {
    data() {
        return {
            menu_name: process.env.VUE_APP_NAME_MENU,
            location_certificado_programa: process.env.VUE_APP_URL_CERT_PROGRAMAS,
            location_programa_portadas: process.env.VUE_APP_URL_PORTADAS,
            form_valido: true,
            activo: true,
            universidades: [],
            postgrado: {categoria:{}},
            postgrados: [],
            sedes: [],
            gestiones: [],
            geztion: {gestion: null,},
            msg: '',
            importado:{ intereses:null },
            showauspicio: 1,
            programa: {
              id:-1,
              version: 1,
              grupo: 1,
              portada: null,
              idpostgrado: null,
              idsede: null,
              iduniversidad: null,
              gestion: null,
              modalidad: 'S', // S,P,V
              nombre_compuesto:'',

              arte: null,
              cuotas: null,
              fase: 1,
              monto_matricula: null,
              monto_colegiatura: null,
              monto_certificacion: null,
              fecha_inicio: null,
              fecha_fin: null,
              modulos:[],

              observacion:'',
            }
        };
    },
    components:{ Fecha,Sedes,Universidades,Gestiones,Alertas,AModulos,Programas },
    validators: {
        'programa.idpostgrado'(value){ return Validator.value(value).required(); },
        'programa.idsede'(value){ return Validator.value(value).required(); },
        //'programa.iduniversidad'(value){ return Validator.value(value); },
        'programa.gestion'(value){ return Validator.value(value).required(); },
        'programa.version'(value){ return Validator.value(value).required().digit().maxLength(2); },
        'programa.grupo'(value){ return Validator.value(value).required().digit().maxLength(2);  },
        'programa.portada'(value){ return Validator.value(value).required(); },
        
        // 'programa.arte'(value){ return Validator.value(value).required(); },
        'programa.cuotas'(value){ return Validator.value(value).digit().greaterThan(0).lessThan(50); },
        'programa.fase'(value){ return Validator.value(value).digit(); },
        'programa.monto_matricula'(value){ return Validator.value(value).digit().greaterThan(-1).lessThan(5000); },
        'programa.monto_colegiatura'(value){ return Validator.value(value).digit().greaterThan(0).lessThan(90000); },
        'programa.monto_certificacion'(value){ return Validator.value(value).digit().greaterThan(-1).lessThan(90000); },
    },
    watch:{ 
        programa: { 
            deep:true,handler(prog){
                if( !prog ) return; 
                window.sessionStorage.setItem( 'xprograma',JSON.stringify(this.programa) ); 
                if( this.$refs.alertar ) this.$refs.alertar.reset();
                //window.console.log( "Mod: programa, ",prog.gestion )
                if( !prog.gestion ) return;
                if( !prog.idsede ) return;
                prog.nombre_compuesto = this.parsePrograma(this.postgrado)+" v"+prog.version+" g"+prog.grupo+" "+prog.gestion.gestion+' s'+prog.idsede.id;
            } 
        },
        'programa.gestion': function(a){
            window.console.log( 'AAAAAAAAAAAa:  ',this.programa )
            this.programa.gestion = a;
            var prog = this.programa;
            if( !prog.gestion ) return;
            if( !prog.idsede ) return;
            prog.nombre_compuesto = this.parsePrograma(this.postgrado)+" v"+prog.version+" g"+prog.grupo+" "+prog.gestion.gestion+' s'+prog.idsede.id;
            if( a== null && a.apertura!=null ) return;
            if( !this.programa.fecha_inicio ) this.programa.fecha_inicio = a.apertura;
        },
    },
    methods:{
        resetPortadaUploader: function(){
            this.programa.portada = null;
            this.$refs.portadaFile.value = '';
        },
        uploadPortadaImg:function(){
            var vue = this;
            const img_cert = this.$refs.portadaFile.files[0];
            window.console.log(img_cert)
            if (img_cert.size/1000 < 1024 ) {
                let url = `${process.env.VUE_APP_URL_WEBDATA}portada_upload.php`;
                let formData = new FormData();
                formData.append('file', img_cert);
                
                xaxios.post( url, formData,{
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(({data:{status, msg, newCertName}})=> {  // applying Destructuring js
                    vue.programa.portada = status ? newCertName : null;
                    vue.$notify( exito( 'PORTADA', msg+newCertName+'dsfs' ) );
                })
                .catch((error)=> {
                    vue.resetPortadaUploader();
                    vue.$notify( error( 'Error: '+url,error ) );
                });
            } else { 
                this.resetPortadaUploader();
                this.$notify( error( 'Portada','El archivo debe ser Menor a 1MB' ) );
            }
        },
        resetImageUploader: function(){
            this.programa.arte = null;
            this.$refs.certificadoFile.value = '';
        },
        uploadImageCert:function(){
            const img_cert = this.$refs.certificadoFile.files[0];
            var vue = this;
            window.console.log(img_cert)
            if (img_cert.size/1000 < 1024 ) {
                let url = `${process.env.VUE_APP_URL_WEBDATA}certificado_upload.php`;
                let formData = new FormData();
                formData.append('file', img_cert);
                
                xaxios.post( url, formData,{
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(({data:{status, msg, newCertName}})=> {  // applying Destructuring js
                    vue.programa.arte = status ? newCertName : null;
                    vue.$notify( exito( 'CERTIFICADO', msg ) );
                })
                .catch((error)=> {
                    vue.resetImageUploader();
                    vue.$notify( error( 'Error: '+url,error ) );
                });
            } else {
                this.resetImageUploader();
                this.$notify( error( 'Certificado','El archivo debe ser Menor a 1MB' ) );
            }
        },
        parsePrograma( p ){
            if( p == null ) return "";
            let cate  = ( p.categoria != null  ) ? p.categoria.nombre : "";
            let post = ( p != null  ) ? p.nombre:"";
            return cate+" - "+post;
        },
        validarCampos(){
            this.$validate().then((success) => {
                var obj = window.Object.assign( {},this.programa );
                window.console.log( window.stringifyObject(obj))
                if( obj.fase ) obj.fase = parseInt( obj.fase );
                if (success) {
                    var idsede = obj.idsede.id;
                    obj.idsede = obj.idsede.id;
                    if( obj.iduniversidad ) obj.iduniversidad = obj.iduniversidad.id;
                    obj.version = parseInt( obj.version );
                    obj.gestion = obj.gestion.gestion;
                    obj.grupo = parseInt( obj.grupo );
                    if( obj.cuotas != null ) obj.cuotas = parseInt( obj.cuotas );
                    if( obj.monto_matricula != null ) obj.monto_matricula = parseInt( obj.monto_matricula );
                    if( obj.monto_colegiatura != null ) obj.monto_colegiatura = parseInt( obj.monto_colegiatura );
                    if( obj.monto_certificacion != null ) obj.monto_certificacion = parseInt( obj.monto_certificacion );
                    this.$store.state.obj = obj;
                    this.$store.dispatch('quitarNulos');
                    if( obj.monto_matricula == null ) obj.monto_matricula = 0; // por si acaso, los valores cero son considerados nulos y los elimina el quitarNulos
                    if( obj.monto_certificacion == null ) obj.monto_certificacion = 0;

                    if( !this.showauspicio ){
                        delete obj.iduniversidad;
                    }
                    if( this.showauspicio && !obj.iduniversidad ){
                        this.$notify( error( 'Auspiciante','Debe seleccionar a la universidad auspiciante.' ) );
                        return;
                    }
                    if( !obj.portada.includes('.') ){
                        this.$notify( error( 'Portada','El nombre de la portada debe tener la extension.' ) );
                        return;
                    }
                    if( obj.modulos == null || obj.modulos.length == 0 ){
                        this.$notify( error( 'Sin modulos','Debe especificar los modulos de este programa.' ) );
                        return;
                    }else{
                        this.validarModulos( obj );
                    }
                    
                    this.form_valido = true;
                    var vue = this;
                    obj.nombre_compuesto = this.parsePrograma(this.postgrado)+" v"+obj.version+" g"+obj.grupo+" "+obj.gestion+' s'+idsede;
                    //obj.nombre_compuesto = 'DIPLOMADO EN TRASTORNOS DEL ESPECTRO AUTISTA v'+obj.version+" g"+obj.grupo+" "+obj.gestion+' s'+idsede;
                    this.$dialog.confirm(this.$store.state.alertmsg).then(function() { vue.enviarDatos( obj )
                    }).catch(function() { vue.$refs.alertar.reset(); });
                    this.$refs.alertar.cargando();

                }else{
                    this.form_valido = false;
                    this.$refs.alertar.invalido();

                    //window.console.log( "HHHHHHHHHHHHHHHHHHHHHHHHHHH",window.stringifyObject(obj) );
                }
            });

        },
        validarModulos( obj ){
            var mods = [];
            obj.modulos.forEach( function(e){
                var doce = typeof(e.iddocente)=='number'? e.iddocente: e.iddocente? e.iddocente.id : null;
                var ob = { idmodulo:e.id,numero:e.numero,inicio:e.inicio,fin:e.fin,iddocente:doce };
                if( ob.inicio == null ) delete ob.inicio;
                if( ob.fin == null ) delete ob.fin;
                if( ob.iddocente == null && typeof(ob.iddocente)=='object' ) {
                    delete ob.iddocente;
                }
                mods.push( ob )
            });
            obj.modulos = mods; 
        },
        getPrograma(){
          var vue = this;
          var sql = gql`query{getPrograma(id:${this.programa.id}){id,nombre_compuesto,version,grupo,fase,fecha_fin,fecha_inicio,modalidad,sede{id,nombre},postgrado{id,nombre,categoria{id,nombre}},universidad{id,nombre},monto_matricula,monto_colegiatura,monto_certificacion,gestion_info{gestion,apertura,cierre},portada,arte,fase,cuotas,programa_modulos{numero,modulo{id,nombre},inicio,fin,docente{id,nombres,pri_apellido,seg_apellido,num_doc}}}}`;
            // window.console.log( "---------------*-*\n",sql );

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
              this.programa = data.data.getPrograma;
              this.programa.portada = data.data.getPrograma.portada;
              this.programa.arte = data.data.getPrograma.arte;
              var mods = [];
              data.data.getPrograma.programa_modulos.sort(function(a, b){return a.numero - b.numero});
              data.data.getPrograma.programa_modulos.forEach(function(e){
                mods.push( {id:e.modulo.id,numero:e.numero,nombre:e.modulo.nombre,inicio:e.inicio,fin:e.fin,iddocente:e.docente,aula:{}} )
              });
              delete this.programa.programa_modulos;
              this.programa.modulos = mods;
              this.postgrado = this.programa.postgrado;
              //window.console.log( 'GETPROGRAMA::: ',this.programa );
              this.programa.idpostgrado = this.programa.postgrado.id;
              this.programa.idsede = this.programa.sede;
              this.programa.iduniversidad = this.programa.universidad;
              this.programa.gestion = this.programa.gestion_info;
              delete this.programa.gestion_info;
              delete this.programa.sede;
              delete this.programa.postgrado;
              delete this.programa.universidad;
              delete this.programa.__typename;
              this.activo = this.programa.fase < 2;

                //window.console.log( "getPrograma: ",window.stringifyObject(this.programa) )
            //   window.initArchivo( this.programa );
            //   window.initArchivo2( this.programa ); // en cuenta de esta linea sea usa this.uploadImageCert

            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(error);
                vue.msg = error;
            })
        },
        enviarDatos( obj ){
            if( obj == null ) obj = JSON.parse( window.sessionStorage.getItem( 'xs_obj' ) );
            delete obj.fase;
            delete obj.observacion;
            var vue = this;
            var sql = gql`mutation{ updatePrograma(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
            vue.msg = '';
            //window.console.log( '\n\n\n',sql,'\n\n\n' );

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                // window.console.log('data.data.updatePrograma', data.data.updatePrograma)
                if(data.data.updatePrograma.ok){
                    vue.$refs.alertar.success();
                    window.sessionStorage.setItem( 'xprograma',null );
                }else{
                    var errores = JSON.stringify(data.data.updatePrograma.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    vue.msg = '';
                    vue.activo = true;
                    vue.$refs.alertar.invalido( vals );
                }
                
                // window.console.log(data);
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(error);
                vue.msg = error;
            })
        },
    },
    mounted(){
      var xp = window.sessionStorage.xprograma;
      if( xp != null ) {
        var op = JSON.parse( xp );
        this.programa.id = op.id;
        //this.postgrado = op.postgrado;
        // window.console.log( '>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',this.postgrado )
      }
      this.getPrograma();

        /*if( sessionStorage.xpostgrado != undefined ) {
            var ob = JSON.parse( window.sessionStorage.xpostgrado );
            
            if( ob != null ) {
                this.postgrado = ob;

                this.programa.idpostgrado = this.postgrado.id;
            }
        }*/

        /*window.initArchivo( this.programa );
        window.console.log( '------------------- '+window.NOMBRE_ARCHIVO )*/
    }
}


</script>